// src/theme.ts
import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#22c55e' // lime/green
    },
    secondary: {
      main: '#38bdf8' // light blue accent
    },
    background: {
      default: '#022c22', // dark green-ish
      paper: '#020617' // dark card
    },
    text: {
      primary: '#e5e7eb',
      secondary: '#9ca3af'
    }
  },
  shape: {
    borderRadius: 24 // rounded corners for cards
  },
  components: {
    // iOS draws the web app full bleed from y=0, because layout.tsx sets
    // appleWebApp statusBarStyle to black-translucent and the viewport to
    // viewportFit cover. Without this padding the Toolbar sits underneath
    // the status bar and, on a device with a Dynamic Island, behind the
    // Island itself: on an iPhone 15 the Fleet Dashboard title was
    // obscured by the clock and the back button was unreachable.
    //
    // Padding the AppBar root rather than the Toolbar extends the bar's
    // own background up into the safe area, so the status bar reads as
    // part of the app instead of a black strip above it. Dropping
    // black-translucent would have been one line, but it shifts every
    // screen down on iOS and puts a black system bar above a dark green
    // app.
    //
    // env(safe-area-inset-top) resolves to 0px on Android and on desktop,
    // so this is inert everywhere except iOS. It depends on viewportFit
    // cover staying in layout.tsx: without it the inset is always zero.
    MuiAppBar: {
      styleOverrides: {
        root: {
          paddingTop: 'env(safe-area-inset-top)'
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 24,
          background:
            'linear-gradient(135deg, rgba(15,23,42,0.95), rgba(15,23,42,0.85))',
          border: '1px solid rgba(148,163,184,0.35)',
          boxShadow:
            '0 20px 40px rgba(0,0,0,0.35), 0 0 0 1px rgba(15,23,42,0.8)'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          backgroundColor: 'rgba(15,23,42,0.9)'
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: 'rgba(34,197,94,0.14) !important'
          },
          '&:hover': {
            backgroundColor: 'rgba(148, 163, 184, 0.12)'
          }
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        h6: {
          fontWeight: 600,
          letterSpacing: 0.3
        }
      }
    }
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      'system-ui',
      'Segoe UI',
      'sans-serif'
    ].join(',')
  }
});
